module.exports = __webpack_public_path__ + "static/media/Intro-AFTER-trialexercises.11a7ffbf.mp3";